/* @flow */

import React from 'react';
import { Icon } from 'semantic-ui-react';

type Props = {
  icon: string,
  circular?: boolean,
  title: string,
};

const IconHeader = ({ icon, title, circular = false }: Props) => (
  <h4 className="ui center aligned icon header">
    <Icon name={icon} circular />
    {title}
  </h4>
);

export default IconHeader;



// WEBPACK FOOTER //
// ./src/shared/components/IconHeader.js